import { ApiError, type EngagementCandidate } from '@clockwise/shared';

/**
 * When a timesheet write (an entry create/patch, or a timer commit) leaves an
 * entry that two or more engagements cover without one chosen, the server
 * refuses it with a 422 whose `ENGAGEMENT_REQUIRED` field error carries the
 * candidates in `constraint.candidates`. Returns them when the error is that
 * one, else null — the caller then asks which engagement and retries the same
 * write with the chosen `engagementId`.
 */
export function engagementRequiredCandidates(err: unknown): EngagementCandidate[] | null {
  if (!(err instanceof ApiError)) return null;
  const field = err.fields?.find((f) => f.code === 'ENGAGEMENT_REQUIRED');
  if (!field) return null;
  const candidates = (field.constraint as { candidates?: unknown } | undefined)?.candidates;
  if (!Array.isArray(candidates)) return [];
  return candidates.filter(
    (c): c is EngagementCandidate =>
      typeof c === 'object' &&
      c != null &&
      typeof (c as { engagementId?: unknown }).engagementId === 'string' &&
      typeof (c as { name?: unknown }).name === 'string',
  );
}
